<template>
  <div>
    <vs-popup fullscreen :title="$t('Products')" :active.sync="showModal">
      <form>
        <div class="vx-row mb-6" v-has-permission="permission40">
          <div class="vx-col lg:w-5/6 w-full">
            <label class="vs-select--label">{{ $t("Products") }}</label>
            <treeselect
              name="agent"
              :multiple="false"
              :placeholder="$t('SearchProduct')"
              :async="true"
              :load-options="loadOptions"
              v-validate="'required'"
              class="search-input"
              ref="product"
              @select="onActualProductSelected"
            />
          </div>
          <div class="vx-col lg:w-1/6 w-full">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="add-btn"
              @click.prevent="assignProduct()"
            ></vs-button>
          </div>
        </div>
      </form>
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[
          { title: $t('ProductName') },
          { title: $t('BrandName') },
          { title: $t('GenericProduct') },
          { title: $t('Action') },
        ]"
      >
        <template slot-scope="{ row }">
          <td style="width: 30%">
            {{ row.persianName }}
          </td>
          <td style="width: 25%">
            {{ row.brandName }}
          </td>
          <td style="width: 25%">
            {{ row.genericProductName }}
          </td>
          <td style="width: 17%">
            <vs-button
              radius
              color="danger"
              size="small"
              type="gradient"
              icon-pack="feather"
              icon="icon-x"
              @click.prevent="unassignProduct(row.id)"
              class="d-inline"
              v-has-permission="permission39"
            ></vs-button>
          </td>
        </template>
      </data-grid>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.add-btn {
  margin-top: 1.5rem;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
const dict = {
  custom: {
    product: {
      required: "لطفا محصول را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_BasicDefinitions_productSegment_ProductPopup",
  props: {
    show: { default: false },
    productModalModel: {
      default: {},
    },
    keywords: {},
  },

  data() {
    return {
      permission39: "RemoveProductInfo",
      permission40: "AddProductInfo",
      gridDataSource: { data: [] },
      gridSearchData: {},
      productInfo: {},
      product: null,
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  methods: {
    ...mapActions({
      assignProductInfo: "productSegment/assignProductInfo",
      searchActualProduct: "actualProduct/fetchSearch",
      unassignProductInfo: "productSegment/unassignProductInfo",
    }),
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.searchActualProduct(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.persianName,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onActualProductSelected(data) {
      this.productInfo.actualProductId = data.id;
      this.product = null;
    },
    assignProduct() {
      this.productInfo.segmentId = this.productModalModel.segmentId;
      this.assignProductInfo(this.productInfo).then(() => {
        this.$vs.notify({
          title: "عملیات موفق",
          text: "رکورد مورد نظر با موفقیت اضافه شد!",
          color: "success",
        });
        this.$refs.grid.renderGrid();
      });
      this.$refs.product.clear();
    },
    unassignProduct(actualProductId) {
      var segmentId = this.productModalModel.segmentId;
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.unassignProductInfo({ segmentId, actualProductId }).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.$validator.reset();
        this.gridDataSource = {
          type: "app",
          service:
            "Sales/api/SegmentQuery/" +
            this.productModalModel.segmentId +
            "/ProductInfo",
        };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      } else {
        this.gridDataSource = { data: [] };
        this.$refs.product.clear();
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      }
    },
  },
  components: {
    Treeselect,
    DataGrid,
    "v-select": vSelect,
  },
};
</script>
